module.exports = __webpack_public_path__ + "img/outlook.9a4cf859.png";